import { Popover, PopoverProps, styled, YStack, isWeb } from '@mythical/ui'
import React from 'react'

import { Button, ButtonProps } from '../Button'
import { IconMore } from '../Icon/icons/IconMore'

const MenuContent = styled(YStack, {
  space: '$2',
  pt: '$3',
  $gtXs: {
    pt: '$0',
    space: '$1.5',
  },
})

export function Menu(props: PopoverProps) {
  return (
    <Popover allowFlip size="$2" {...props}>
      <Popover.Trigger asChild>
        <Button theme="tertiary" mb="$1.5" p="$2" h="$2.5" px="$0">
          <IconMore color="$secondary6" />
        </Button>
      </Popover.Trigger>

      <Popover.Adapt platform="native" when="xxl">
        <Popover.Sheet modal dismissOnSnapToBottom snapPoints={[35, 30]}>
          <Popover.Sheet.Frame bg="$secondary10" p="$3" pt="$4">
            <Popover.Sheet.Handle />
            <Popover.Adapt.Contents />
          </Popover.Sheet.Frame>
          <Popover.Sheet.Overlay animation="quick" bg="transparent" />
        </Popover.Sheet>
      </Popover.Adapt>

      <Popover.Content
        borderWidth={1}
        borderColor="$secondary10"
        elevation="$4"
        enterStyle={{ x: 0, y: -10, opacity: 0 }}
        exitStyle={{ x: 0, y: -10, opacity: 0 }}
        bg="$secondary9"
        x={0}
        y={0}
        opacity={1}
        animation={[
          'quick',
          {
            opacity: {
              overshootClamping: true,
            },
          },
        ]}
        elevate
      >
        <Popover.Arrow
          borderWidth={1}
          bg="$secondary8"
          borderColor="$secondary8"
        />
        <MenuContent>{props.children}</MenuContent>
      </Popover.Content>
    </Popover>
  )
}

export function MenuItem(props: ButtonProps) {
  return (
    <Button
      {...props}
      size="$3"
      borderRadius="$2"
      borderWidth={0}
      theme="tertiary"
      borderColor="transparent"
    />
  )
}
